import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import { defineComponent, watch } from 'vue';
import Banner from '@/components/Banner.vue';
import ContestCard from './components/ContestCard.vue';
import { useRoute, useRouter } from 'vue-router';
import { ActivityService } from '@/services/activity.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import emptyImage from '@/assets/image/home/empty.png';
import BannerImage from '@/assets/image/banner/banner1@2x.png';
import NavHeader from '@/components/NavHeader.vue';
export default defineComponent({
  name: 'ActivityDetail',
  components: {
    Banner: Banner,
    ContestCard: ContestCard,
    NavHeader: NavHeader
  },
  setup: function setup() {
    declareProviders([ActivityService]);
    var activityService = useService(ActivityService);
    var route = useRoute();
    var router = useRouter();

    var initPageData = function initPageData() {
      var params = route.params;

      if (params.type) {
        if (params.type === 'list') {
          activityService.isActivityList = true;
        } else {
          activityService.isActivityList = false;
          activityService.setActivityType(+params.type);
        }
      }

      if (params.activityId) {
        activityService.setActivityId(+params.activityId);
      }

      if (params.itemId) {
        activityService.setContestId(+params.itemId);
      }

      activityService.init();
    };

    var onPageNumChange = function onPageNumChange(page) {
      activityService.setPageNum(page);
      activityService.search();
    };

    var onShowSizeChange = function onShowSizeChange(current, pageSize) {
      activityService.setPageNum(current);
      activityService.setPageSize(pageSize);
      activityService.search();
    };

    var onContestCardClick = function onContestCardClick(item) {
      router.push({
        name: 'ItemDetail',
        params: {
          id: item.contestId
        }
      });
    };

    var onActivityTypeChange = function onActivityTypeChange(item) {
      activityService.setActivityType(item.code);
      activityService.resetSearch();
    };

    watch(route, function () {
      if (route.name === 'ActivityDetail') {
        initPageData();
      }
    }, {
      immediate: true
    });
    return {
      onPageNumChange: onPageNumChange,
      onShowSizeChange: onShowSizeChange,
      onContestCardClick: onContestCardClick,
      onActivityTypeChange: onActivityTypeChange,
      activityService: activityService,
      emptyImage: emptyImage,
      BannerImage: BannerImage
    };
  }
});